/*
 * Wanneer een Snize-productkaartje twee labels heeft (bv. "new" en
 * "premium"), rendert Snize die zelf als ".top-left" en ".down-left" (of
 * ".bottom-left" als het label alleen staat, zonder "new") - wat standaard
 * betekent dat het tweede label ONDER het eerste komt. Hier moet het
 * tweede label net naast ("achter") het eerste komen te staan wanneer er
 * een "new"-label is, en anders op de plek van ".top-left" blijven staan
 * (zie de CSS-fallback in snize-filters.css).
 *
 * De breedte van het "new"-label hangt af van lettertype/tekst en kan dus
 * niet vooraf in CSS vastgezet worden, dus die wordt hier gemeten.
 */
(function () {
  var GAP = 6; // px tussen de twee labels
  var BASE_LEFT = 8; // moet gelijk blijven aan de "left" in snize-filters.css

  function positionLabels(wrapper) {
    var topLeft = wrapper.querySelector(':scope > .snize-product-label.top-left');
    var downLeft = wrapper.querySelector(
      ':scope > .snize-product-label.down-left, :scope > .snize-product-label.bottom-left'
    );
    if (!downLeft) return;

    if (topLeft) {
      var width = topLeft.getBoundingClientRect().width;
      downLeft.style.setProperty('left', BASE_LEFT + width + GAP + 'px', 'important');
    } else {
      downLeft.style.removeProperty('left');
    }
  }

  function processAll() {
    document
      .querySelectorAll('#snize-search-results-grid-mode .snize-item .snize-thumbnail-wrapper')
      .forEach(positionLabels);
  }

  var pending = false;
  var mutationObserver = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      processAll();
    });
  });

  mutationObserver.observe(document.body, { childList: true, subtree: true });

  processAll();
})();
